import React from 'react'
import PropTypes from 'prop-types';
import { Box, Checkbox, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel } from '@mui/material'
import { visuallyHidden } from '@mui/utils';


const rows = [
    {
        id: 1,
        nombreProducto: 'Coca Cola',
        cantidad: 25,
        costo: 2.50,
        total: 25 * 2.5,
        ubicacion: 'Almacen',
        vencimiento: new Date('2024/06/18'),
    },
    {
        id: 2,
        nombreProducto: 'Leche Pil',
        cantidad: 36,
        costo: 7.30,
        total: 36 * 7.30,
        ubicacion: 'Tienda',
        vencimiento: new Date('2024/09/11'),
    },
    {
        id: 3,
        nombreProducto: 'Jamon Stege',
        cantidad: 19,
        costo: 11.00,
        total: 19 * 11.00,
        ubicacion: 'Almacen',
        vencimiento: new Date('2025/02/23'),
    },
    {
        id: 4,
        nombreProducto: 'Dulce de leche',
        cantidad: 28,
        costo: 12.50,
        total: 28 * 12.50,
        ubicacion: 'Almacen',
        vencimiento: new Date('2024/07/09'),
    },
    {
        id: 5,
        nombreProducto: 'Arroz Chino',
        cantidad: 23,
        costo: 9.10,
        total: 23 * 9.10,
        ubicacion: 'Tienda',
        vencimiento: new Date('2024/02/10'),
    },
];


function EnhancedTableHead(props) {
    const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
        props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                <TableCell padding="checkbox">
                    <Checkbox
                        color="primary"
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={rowCount > 0 && numSelected === rowCount}
                        onChange={onSelectAllClick}
                        inputProps={{
                            'aria-label': 'select all desserts',
                        }}
                    />
                </TableCell>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <Box component="span" sx={visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </Box>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

/* Esto sirve para verificar los tipos de datos solo en tiempo de desarrollo, para asegurar un mejor código */
EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}


const headCells = [
    {
        id: 'id',
        numeric: true,
        type: 'numeric',
        disablePadding: true,
        label: 'Id',
    },
    {
        id: 'nombreProducto',
        numeric: false,
        type: 'text',
        disablePadding: true,
        label: 'Producto',
    },
    {
        id: 'cantidad',
        numeric: true,
        type: 'numeric',
        disablePadding: false,
        label: 'Cantidad',
    },
    {
        id: 'costo',
        numeric: true,
        type: 'numeric',
        disablePadding: false,
        label: 'Costo',
    },
    {
        id: 'total',
        numeric: true,
        type: 'numeric',
        disablePadding: false,
        label: 'Total',
    },
    {
        id: 'vencimiento',
        numeric: true,
        type: 'date',
        disablePadding: false,
        label: 'Vencimiento',
    },
    {
        id: 'ubicacion',
        numeric: true,
        type: 'text',
        disablePadding: false,
        label: 'Ubicación',
    },
];


const AlmacenTabla2 = () => {
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('calories');
    const [selected, setSelected] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [dense, setDense] = React.useState(false);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = rows.map((n) => n.id);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, id) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleChangeDense = (event) => {
        setDense(event.target.checked);
    };

    const isSelected = (id) => selected.indexOf(id) !== -1;

    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

    const visibleRows = React.useMemo(
        () =>
            stableSort(rows, getComparator(order, orderBy)).slice(
                page * rowsPerPage,
                page * rowsPerPage + rowsPerPage,
            ),
        [order, orderBy, page, rowsPerPage],
    );

    return (
        <TableContainer>
            <Table
                sx={{ minWidth: 750 }}
                aria-labelledby="tableTitle"
            //size={dense ? 'small' : 'medium'}
            >
                <EnhancedTableHead
                    numSelected={selected.length}
                    order={order}
                    orderBy={orderBy}
                    onSelectAllClick={handleSelectAllClick}
                    onRequestSort={handleRequestSort}
                    rowCount={rows.length}
                />


                <TableBody>
                    {visibleRows.map((row, index) => {
                        const isItemSelected = isSelected(row.id);
                        const labelId = `enhanced-table-checkbox-${index}`;

                        return (
                            <TableRow
                                hover
                                onClick={(event) => handleClick(event, row.id)}
                                role="checkbox"
                                aria-checked={isItemSelected}
                                tabIndex={-1}
                                key={row.id}
                                selected={isItemSelected}
                                sx={{ cursor: 'pointer' }}
                            >
                                <TableCell padding="checkbox">
                                    <Checkbox
                                        color="primary"
                                        checked={isItemSelected}
                                        inputProps={{
                                            'aria-labelledby': labelId,
                                        }}
                                    />
                                </TableCell>
                                <TableCell
                                    component="th"
                                    id={labelId}
                                    scope="row"
                                    padding="none"
                                >
                                    {row.id}
                                </TableCell>
                                <TableCell align="right">{row.nombreProducto}</TableCell>
                                <TableCell align="right">{row.cantidad}</TableCell>
                                <TableCell align="right">{row.costo}</TableCell>
                                <TableCell align="right">{row.total}</TableCell>
                                <TableCell align="right">{row.vencimiento.toISOString().split('T')[0]}</TableCell>
                                <TableCell align="right">{row.ubicacion}</TableCell>        

                            </TableRow>
                        );
                    })}
                    {emptyRows > 0 && (
                        <TableRow
                            style={{
                                height: (dense ? 33 : 53) * emptyRows,
                            }}
                        >
                            <TableCell colSpan={6} />
                        </TableRow>
                    )}
                </TableBody>





            </Table>
        </TableContainer>
    )
}

export default AlmacenTabla2